import { ShowToast } from "src/components/Toast";
import { useState } from "react";

type ToastType = {
  message: string;
  messageType: "success" | "error" | "warning" | "info";
  timeout: number;
};
export function Button({
  id,
  onClick,
  title,
  buttonType,
  toast,
  className,
  formId,
  disabled,
}: {
  id?: string | number;
  onClick?: () => void;
  title: string;
  className?: string;
  buttonType?: "button" | "submit" | "reset";
  toast?: ToastType;
  formId?: string;
  disabled?: boolean;
}) {
  const timeoutValue = toast?.timeout || 3000;
  return (
    <button
      id={String(id)}
      type={buttonType || "button"}
      form={formId}
      className={`p-2 border-Grey4 border-2 rounded-xl bg-PrimaryGreen text-White  ${className} ${
        disabled ? "bg-Grey4 border-Grey7 cursor-not-allowed text-Grey9 " : ""
      }`}
      onClick={(e) => {
        e.preventDefault();
        if (toast)
          ShowToast(
            toast.message,
            toast.messageType || "success",
            timeoutValue,
            () => {}
          );
        setTimeout(() => {}, timeoutValue);
        if (onClick) {
          onClick();
        }
      }}
      disabled={disabled}
    >
      {title}
    </button>
  );
}
